import * as types from '../types.js';

export default {

	html: `
		<style>
			#category {
				box-sizing: border-box;
				width: min(46rem, calc(100vw - 1.5rem));
				max-width: calc(100vw - 1.5rem);
				min-width: 0;
			}
			#category #company_id	{ width: 10rem;		}
			#category #id			{ width: 4.5rem; text-align: right;	}
			#category #name			{ width: 10rem;		}
			#category .name 		{ width: 100%; box-sizing: border-box; }
			#category .length 		{ width: 100%; box-sizing: border-box; text-align: right;	}
			#category .attr-help {
				margin: 0.5rem 0 1rem;
				padding: 0.75rem;
				background: var(--form-hint-bg, #f5f5f5);
				border-radius: 4px;
				font-size: 0.9rem;
				line-height: 1.4;
				max-width: 100%;
			}
			#category .attr-help code { padding: 0.1em 0.4em; background: #e0e0e0; border-radius: 3px; font-size: 0.9em; }
			#category .attr-section { min-width: 0; max-width: 100%; }
			#category .attr-section table {
				width: 100%;
				max-width: 100%;
				table-layout: fixed;
			}
			#category .attr-section th,
			#category .attr-section td {
				white-space: normal;
				vertical-align: top;
				overflow-wrap: anywhere;
			}
			#category .attr-section th:nth-child(1),
			#category .attr-section td:nth-child(1) { width: 2.4rem; }
			#category .attr-section th:nth-child(3),
			#category .attr-section td:nth-child(3) { width: 8.5rem; }
			#category .attr-section th:nth-child(4),
			#category .attr-section td:nth-child(4) { width: 5.5rem; text-align: center; }
			#category .attr-section th small {
				font-weight: normal;
				color: #666;
				display: block;
				margin-top: 0.2rem;
				line-height: 1.3;
				white-space: normal;
			}
		</style>
		<form id="category" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da categoria">Categoria
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da categoria">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="attr-section">
				<p class="attr-help">
					<strong>Estrutura do SKU:</strong> Os atributos definem como o código do produto (SKU) será organizado.
					Cada linha é um segmento do SKU. O <em>tamanho</em> indica quantos caracteres esse segmento terá (1–12).
					Use um número (ex: 6) ou vários separados por vírgula (ex: 5,6,10) quando o segmento puder ter tamanhos diferentes.
					Ex.: <strong>Substância(3)</strong>, <strong>Concentração(1)</strong>, <strong>Embalagem(1)</strong> → SKU como <code>PRD,5,C</code>.
				</p>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Atributo<sup>*</sup><br><small>Nome do segmento (ex: Substância, Concentração)</small></th>
							<th>Tamanho<sup>*</sup><br><small>Um número ou vários separados por vírgula (ex: 6 ou 5,6,10)</small></th>
							<th>Opcional<br><small>Pode ficar em branco?</small></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="6">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Nome do atributo exibido no cadastro do produto (ex: Substância, Fabricante)">
								<input id="name-0" class="name" type="text" required placeholder="ex: Produto">
							</td>
							<td title="Um número (ex: 6) ou vários separados por vírgula (ex: 5,6,10) para aceitar múltiplos tamanhos">
								<input id="length-0" class="length" type="text" required placeholder="ex: 6 ou 5,6,10">
							</td>
							<td title="Marcar se este atributo pode ser omitido no SKU">
								<input id="is_optional-0" class="optional" type="checkbox">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#category',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#name-0' }, types: [types.name()] },
		{ properties: { selector: '#length-0' }, types: [types.obs_sku_length()]},
		{ properties: { selector: '#is_optional-0' }, types: [types.checkbox()] },
	]

};

